import Vue from 'vue'
import { Map, TileLayer, Feature, PointGeom, OsmSource, StyleBox, IconStyle } from 'vuelayers'
import 'vuelayers/lib/style.css'

Vue.use(Map)
Vue.use(TileLayer)
Vue.use(Feature)
Vue.use(PointGeom)
Vue.use(OsmSource)
Vue.use(StyleBox)
Vue.use(IconStyle)
